/* ─────────────────────────────────────────────
   禾宁初 HONIN CHU · Theme JS  v3
   ───────────────────────────────────────────── */
(function () {
  'use strict';

  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    }, opts || {})).then(r => r.json());
  }

  function toast(msg) {
    let t = document.getElementById('hn-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'hn-toast';
      t.style.cssText = 'position:fixed;bottom:80px;left:50%;transform:translateX(-50%);background:#2b2620;color:#f5efe6;padding:12px 24px;border-radius:2px;font-size:13px;letter-spacing:0.05em;z-index:99999;pointer-events:none;white-space:nowrap;display:none;';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.display = 'block';
    clearTimeout(t._timer);
    t._timer = setTimeout(function() { t.style.display = 'none'; }, 2500);
  }
  window.HNToast = toast;

  const Cart = {
    open: function() {
      $('.hn-drawer') && $('.hn-drawer').classList.add('is-open');
      $('.hn-drawer-overlay') && $('.hn-drawer-overlay').classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },
    close: function() {
      $('.hn-drawer') && $('.hn-drawer').classList.remove('is-open');
      $('.hn-drawer-overlay') && $('.hn-drawer-overlay').classList.remove('is-open');
      document.body.style.overflow = '';
    },
    refresh: async function() {
      try {
        var cartData = await fetch('/cart.js', {credentials:'same-origin'}).then(function(r){return r.json();});
        var newCount = String(cartData.item_count);
        var html = await fetch('/?section_id=cart-drawer-contents').then(function(r){return r.text();});
        var wrap = document.createElement('div');
        wrap.innerHTML = html.trim();
        var newBody = wrap.querySelector('.hn-drawer-body-inner');
        var newFoot = wrap.querySelector('.hn-drawer-foot-inner');
        if (newBody) { var ob = $('.hn-drawer-body-inner'); ob && ob.replaceWith(newBody); }
        if (newFoot) { var of2 = $('.hn-drawer-foot-inner'); of2 && of2.replaceWith(newFoot); }
        var footWrap = $('.hn-drawer-foot');
        if (footWrap) { footWrap.style.display = cartData.item_count > 0 ? 'block' : 'none'; }
        var checkoutBtn = document.querySelector('.hn-drawer-foot .hn-btn-primary');
        if (checkoutBtn && checkoutBtn.tagName === 'A') { checkoutBtn.href = '/cart'; }
        if (checkoutBtn && checkoutBtn.tagName === 'BUTTON') {
          var f = checkoutBtn.closest('form'); if (f) f.action = '/cart';
          checkoutBtn.removeAttribute('name');
        }
        $$('[data-cart-count]').forEach(function(el) {
          el.textContent = newCount;
          el.style.display = +newCount > 0 ? '' : 'none';
        });
        var drawerHead = $('.hn-drawer-head h3 span');
        if (drawerHead) { drawerHead.textContent = newCount + ' 件'; }
      } catch(e) { console.error('Cart refresh error:', e); }
    },
    setLoading: function(on) {
      var body = $('.hn-drawer-body-inner');
      if (body) body.style.opacity = on ? '0.4' : '';
    },
    add: async function(formOrPayload, evt) {
      var variantId = null;
      var quantity = 1;
      if (formOrPayload instanceof HTMLFormElement) {
        var fd = new FormData(formOrPayload);
        variantId = fd.get('id');
        quantity = parseInt(fd.get('quantity') || '1');
      } else if (formOrPayload && formOrPayload.items) {
        variantId = String(formOrPayload.items[0].id);
        quantity = formOrPayload.items[0].quantity || 1;
      }
      var body = formOrPayload instanceof HTMLFormElement ? new FormData(formOrPayload) : JSON.stringify(formOrPayload);
      var headers = formOrPayload instanceof HTMLFormElement ? { 'Accept': 'application/json' } : { 'Accept': 'application/json', 'Content-Type': 'application/json' };
      var res = await fetch('/cart/add.js', { method: 'POST', body: body, headers: headers, credentials: 'same-origin' });
      var data = await res.json();
      if (!res.ok) { toast('该尺码库存已达加购上限，请选择其他尺码'); return; }
      Cart.flyAnimation(evt);
      Cart.setLoading(true);
      await Cart.refresh();
      Cart.setLoading(false);
      Cart.open();
      setTimeout(function() {
        var checkoutBtn = document.querySelector('.hn-drawer-foot .hn-btn-primary');
        if (checkoutBtn && checkoutBtn.tagName === 'A') { checkoutBtn.href = '/cart'; }
        if (checkoutBtn && checkoutBtn.tagName === 'BUTTON') {
          checkoutBtn.closest('form') && (checkoutBtn.closest('form').action = '/cart');
          checkoutBtn.removeAttribute('name');
        }
      }, 300);
    },
    update: async function(line, qty) {
      var res = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      });
      var data = await res.json();
      if (!res.ok) { toast('该尺码库存已达加购上限'); return; }
      await Cart.refresh();
    },
    flyAnimation: function(evt) {
      if (!evt || !evt.clientX) return;
      var ball = document.createElement('div');
      ball.className = 'hn-fly-ball';
      ball.style.left = (evt.clientX - 12) + 'px';
      ball.style.top = (evt.clientY - 12) + 'px';
      var cartBtn = $('[data-cart-open]');
      var r = cartBtn && cartBtn.getBoundingClientRect();
      var targetX = r ? r.left + r.width / 2 : window.innerWidth - 60;
      var targetY = r ? r.top + r.height / 2 : 30;
      ball.style.setProperty('--fly-end-x', (targetX - evt.clientX) + 'px');
      ball.style.setProperty('--fly-end-y', (targetY - evt.clientY) + 'px');
      document.body.appendChild(ball);
      setTimeout(function() { ball.remove(); }, 700);
    }
  };

  window.HNCart = Cart;

  document.addEventListener('click', function(e) {
    var openBtn = e.target.closest('[data-cart-open]');
    var closeBtn = e.target.closest('[data-cart-close]');
    var overlay = e.target.closest('.hn-drawer-overlay');
    if (openBtn) { e.preventDefault(); Cart.open(); }
    if (closeBtn || overlay) { Cart.close(); }
  });

  document.addEventListener('click', async function(e) {
    var inc = e.target.closest('[data-qty-inc]');
    var dec = e.target.closest('[data-qty-dec]');
    var rm = e.target.closest('[data-cart-remove]');
    if (inc) {
      var line = +inc.dataset.line;
      var qtyWrap = inc.closest('.hn-qty');
      var cur = +(qtyWrap && qtyWrap.querySelector('.num') ? qtyWrap.querySelector('.num').textContent : 1);
      await Cart.update(line, cur + 1);
    }
    if (dec) {
      var line2 = +dec.dataset.line;
      var qtyWrap2 = dec.closest('.hn-qty');
      var cur2 = +(qtyWrap2 && qtyWrap2.querySelector('.num') ? qtyWrap2.querySelector('.num').textContent : 1);
      await Cart.update(line2, Math.max(0, cur2 - 1));
    }
    if (rm) {
      e.preventDefault();
      await Cart.update(+rm.dataset.line, 0);
    }
    if ((inc || dec || rm) && window.location.pathname === '/cart') {
      window.location.reload();
    }
  });

  document.addEventListener('click', async function(e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.variantId;
    var hasMultipleVariants = btn.dataset.hasMultipleVariants === 'true';
    if (!variantId) { window.location = btn.dataset.url || '/'; return; }
    if (hasMultipleVariants) {
      window.location = btn.dataset.url || '/';
      return;
    }
    await Cart.add({ items: [{ id: +variantId, quantity: 1 }] }, e);
  });

  document.addEventListener('submit', async function(e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    await Cart.add(form, { clientX: e.clientX || window.innerWidth - 100, clientY: e.clientY || 100 });
  });

  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var main = $('[data-main-image]');
    if (!main) return;
    var src = thumb.dataset.src;
    if (src) {
      main.src = src;
      $$('[data-thumb]').forEach(function(t) { t.classList.toggle('is-active', t === thumb); });
    }
  });

  document.addEventListener('click', function(e) {
    var sizeBtn = e.target.closest('[data-size-option]');
    if (sizeBtn) {
      var form = sizeBtn.closest('form');
      var group = sizeBtn.closest('[data-size-group]');
      $$('[data-size-option]', group).forEach(function(b) { b.classList.toggle('is-active', b === sizeBtn); });
      var hidden = $('input[name="properties[尺码]"]', form);
      if (hidden) hidden.value = sizeBtn.textContent.trim();
      if (form) {
        var select = $('select[name="id"]', form);
        if (select) {
          var val = sizeBtn.textContent.trim();
          var optFound = Array.from(select.options).find(function(o) {
            // 获取当前选中的发货时效
            var shippingGroup = form.querySelector('[data-shipping-group]') || form.querySelector('[data-size-group]').parentElement.querySelector('[data-size-group]:last-child');
            var activeShipping = form.querySelector('[data-size-option].is-active:not([data-size-group] [data-size-option])');
            var activeShippingBtn = null;
            // 找到发货时效组的active按钮
            var allGroups = form.querySelectorAll('[data-size-group]');
            if (allGroups.length > 1) {
              activeShippingBtn = allGroups[1].querySelector('[data-size-option].is-active');
            }
            var shippingVal = activeShippingBtn ? activeShippingBtn.textContent.trim() : '';
            if (shippingVal) {
              return o.textContent.includes(val) && o.textContent.includes(shippingVal);
            }
            return o.textContent.includes(val);
          });
          if (optFound) {
            select.value = optFound.value;
            var addBtn = $('button[type="submit"]:not([name="checkout"])', form);
            var buyBtn = $('button[name="checkout"]', form);
            if (addBtn) {
              addBtn.disabled = false;
              addBtn.textContent = '加入购物车';
            }
            if (buyBtn) buyBtn.disabled = false;
          }
        }
      }
    }

    var colorBtn = e.target.closest('[data-color-option]');
    if (colorBtn) {
      var group2 = colorBtn.closest('[data-color-group]');
      $$('[data-color-option]', group2).forEach(function(b) { b.classList.toggle('is-active', b === colorBtn); });
    }
  });

  document.addEventListener('click', function(e) {
    var inc = e.target.closest('[data-pdp-qty-inc]');
    var dec = e.target.closest('[data-pdp-qty-dec]');
    if (!inc && !dec) return;
    var input = (inc || dec).parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    var cur = +input.value || 1;
    input.value = inc ? cur + 1 : Math.max(1, cur - 1);
  });

  document.addEventListener('click', function(e) {
    var tab = e.target.closest('[data-pdp-tab]');
    if (!tab) return;
    var id = tab.dataset.pdpTab;
    $$('[data-pdp-tab]').forEach(function(t) { t.classList.toggle('is-active', t === tab); });
    $$('[data-pdp-panel]').forEach(function(p) { p.style.display = p.dataset.pdpPanel === id ? '' : 'none'; });
  });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    btn.classList.toggle('is-wished');
  });

  var Modal = {
    open: function(id) {
      var m = document.getElementById(id);
      if (!m) return;
      m.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },
    close: function(m) {
      m.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  };

  document.addEventListener('click', function(e) {
    var open = e.target.closest('[data-modal-open]');
    var close = e.target.closest('[data-modal-close]');
    if (open) { e.preventDefault(); Modal.open(open.dataset.modalOpen); }
    if (close) Modal.close(close.closest('.hn-modal-overlay'));
    if (e.target.classList.contains('hn-modal-overlay')) Modal.close(e.target);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var open = $('.hn-modal-overlay.is-open');
      if (open) Modal.close(open);
      Cart.close();
    }
  });

  $$('input[name="quantity"]').forEach(function(i) { if (!i.min) i.min = '1'; });

  var term = document.querySelector('[data-solar-current]');
  if (term) {
    var today = new Date();
    var md = String(today.getMonth() + 1).padStart(2,'0') + '.' + String(today.getDate()).padStart(2,'0');
    var allTerms = $$('[data-solar-term]');
    var currentIdx = 0;
    allTerms.forEach(function(el, i) { if (md >= el.dataset.solarTerm) currentIdx = i; });
    allTerms.forEach(function(el, i) { el.classList.toggle('is-current', i === currentIdx); });
    var cur = allTerms[currentIdx];
    if (cur) {
      term.querySelector('[data-solar-current-name]').textContent = cur.dataset.solarTermName;
      term.querySelector('[data-solar-current-poem]').textContent = cur.dataset.solarTermPoem || '';
    }
  }
})();